import React, { useEffect, useState, useRef, useCallback, useContext } from "react";
import Message from "./Message";
import "./chatting.css";
import axios from "axios";
import { useParams } from "react-router-dom";
import PicMa from "../../../Assets/Images/LiveChat/Live.png";
import { io } from "socket.io-client";
import Picker from "emoji-picker-react";
import { useFilePicker } from "use-file-picker";
import ReactTags from "react-tag-autocomplete";
import TextInput from "react-autocomplete-input";
import "react-autocomplete-input/dist/bundle.css";
import { serverInfo } from "../../../App";

const Chatting = ({ participant, groupInfo, color, chatUser, props }) => {


  const { imageCdnUrl, shoketUrl } = useContext(serverInfo);

  const [arrivalMessage, setArrivalMessage] = useState(null);
  const [newMessage, setNewMessage] = useState("");
  const [messages, setMessages] = useState([]);
  const scrollRef = useRef();
  const socket = useRef();
  const params = useParams();
  const [showPicker, setShowPicker] = useState(false);
  const [userInfo, setUserInfo] = useState({});
  const [tagArray, setTagArray] = useState([
    "apple",
    "apricot",
    "banana",
    "carrot",
  ]);
  const [userList, setUserList] = useState([]);

  const [searchName, setSearchName] = useState();
  const [mentionStatus, setMentionStatus] = useState(false);
  const [starList, setStarList] = useState();

  const onEmojiClick = (event, emojiObject) => {
    setNewMessage((prevInput) => prevInput + emojiObject.emoji);
    setShowPicker(false);
  };

  useEffect(() => {
    socket.current = io(shoketUrl);
    socket.current.emit("join_room", groupInfo.room_id);
  }, [params, groupInfo, participant]);

  const namedArray = userList.reduce((acc, cur) => {
    const firstName = cur?.user.first_name;
    const lastName = cur?.user?.last_name;
    const fullName = firstName.concat(lastName);
    acc.push(fullName);
    return acc;
  }, []);

  // setTagArray(namedArray)

  useEffect(() => {
    localStorage.getItem("auth_token") &&
      axios.get(`api/user_info`).then((res) => {
        if (res.data.status === 200) {
          setUserInfo(res.data.users);
        }
      });

    axios
      .get(`/api/mobile/fan-group-chat-history/${groupInfo.id}`)
      .then((res) => {
        if (res.data.status === 200) {
          setMessages(res.data.chat_history);
        }
      });
  }, [groupInfo]);

  useEffect(() => {
    socket.current.on("recive_message", (data) => {
      setMessages((prv) => {
        return [...prv, data];
      });
    });

  }, []);

  const ref = useRef(newMessage);

  const handleSubmit = async (e) => {
    e.preventDefault();

    setNewMessage("");

    if (newMessage) {
      setMentionStatus(false);
      const receiverId = 0;
      let time =
        new Date(Date.now()).getHours() +
        ":" +
        new Date(Date.now()).getMinutes();
      let messageData = {
        sender_id: userInfo.id,
        room_id: groupInfo.room_id,
        sender_name: userInfo.first_name,
        sender_image: userInfo.image,
        group_id: groupInfo.id,
        position: color,
        text: newMessage,
        time: time,
        status: 1,
      };

      socket.current.emit("send_message", messageData);
      setMessages((prv) => {
        return [...prv, messageData];
      });
      setNewMessage("");
    }
    ref.current.value = "";
    setNewMessage("");
  };

  useEffect(() => {
    scrollRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [messages]);

  const [openFileSelector, { filesContent, loading, errors }] = useFilePicker({
    readAs: "DataURL",
    accept: "image/*",
    multiple: true,
    limitFilesConfig: { max: 2 },
    maxFileSize: 50,
  });

  if (loading) {
    return <div>Loading...</div>;
  }

  if (errors.length) {
    return <div>Error...</div>;
  }

  const HendelMessageType = (text) => {
    setNewMessage(text);

    if (text?.includes("@")) {
      setSearchName(text);
      handleFilterData(text, "first_name", "last_name");
      setMentionStatus(true);
    } else {
      setMentionStatus(false);
    }
  };

  /**
   * filter data
   */

  const handleFilterData = (value, ...props) => {
    setMentionStatus(false);
    let serachString = value.split("@");
    let stringValue = serachString[1];

    let array = participant?.filter((item) => {
      let state = false;

      props.forEach((property) => {
        if (
          item.user[property]?.toLowerCase().includes(stringValue.toLowerCase())
        ) {
          state = true;
        }
      });

      return state;
    });


    if (value.length > 0) {
      setStarList(array);
    } else {
      setStarList([]);
    }
  };

  const HandelPressMentaion = (value) => {
    let serachString = newMessage.split("@");
    let stringValue = serachString[0];
    setNewMessage(stringValue + value);
    setMentionStatus(false);
  };

  const inputHandler = (e) => {
    // setData(e.target.value)

    setNewMessage(e.target.value);
  };

  return (
    <>
      <div className="chatBoxTop container MessengerBodyText py-2 ps-2 text-light">
        {messages.map((m) => (
          <div ref={scrollRef}>
            <Message message={m} userInfo={userInfo} />
          </div>
        ))}
      </div>
      {mentionStatus && (
        <div
          style={{
            height: "150px",
            width: "100%",
            backgroundColor: "#dddddd65",
            overflowX: "scroll",
            paddingRight: "20px",
            paddingTop: "10px",
          }}
        >
          <ul style={{ listStyle: "none" }}>
            {starList &&
              starList.map((item, i) => (
                <li
                  key={i}
                  style={{
                    backgroundColor: "black",
                    color: "#fff",
                    padding: "10px 10px",
                    border: "1px solid #fff",
                    marginBottom: "5px",
                    borderRadius: 50,
                    cursor: "pointer",
                  }}
                  onClick={() =>
                    HandelPressMentaion(
                      `@${item.user.first_name + " " + item.user?.last_name}`
                    )
                  }
                >
                  <img
                    className="messageImg"
                    src={imageCdnUrl + item.user.image}
                    alt=""
                  />
                  {item.user.first_name + " " + item.user?.last_name}
                </li>
              ))}
          </ul>
        </div>
      )}
      <form onSubmit={handleSubmit}>
        <div className="d-flex MessengerFooter  p-2 text-light">
          <div className="IconMessage col-md-2 me-3 d-flex">
            <i
              onClick={() => setShowPicker((val) => !val)}
              className="text-light IconMessageT fa-solid fa-face-smile f-25 ms-2 mt-1"
            ></i>
          </div>

          <div className="IconMessage col-md-7 d-flex">
            <input
              className="form-control"
              onChange={(e) => HendelMessageType(e.target.value)}
              value={newMessage}
            />
          </div>

          <div
            className="IconMessage col-md-1 d-flex ms-2"
            onClick={handleSubmit}
          >
            <i className=" mt-2 text-light IconMessageT SendT text-left fa-brands fa-telegram f-25"></i>
          </div>
        </div>
      </form>

      {showPicker && (
        <Picker pickerStyle={{ width: "100%" }} onEmojiClick={onEmojiClick} />
      )}
    </>
  );
};

export default Chatting;
